module.exports = __webpack_public_path__ + "static/img/health1.e394864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/health1.png
// module id = bbwO
// module chunks = 1